module.exports = __webpack_public_path__ + "img/Dah-Sing.e55b752e.png";